import { NewHabitType, OldHabitType } from '../components/TargetScores'

export const habitTypeMap: { [key in OldHabitType]: NewHabitType } = {
  Sleep: 'sleep',
  'Planned Day': 'plannedDay',
  'Main Priority': 'miw',
  Exercise: 'fitness',
  Nutrition: 'nutrition',
  'Personal Challenge': 'personalChallenge',
  Love: 'love'
}

export const habitTypeNameMap: { [key in NewHabitType]: OldHabitType } = {
  sleep: 'Sleep',
  plannedDay: 'Planned Day',
  miw: 'Main Priority',
  fitness: 'Exercise',
  nutrition: 'Nutrition',
  personalChallenge: 'Personal Challenge',
  love: 'Love',
}

export const habitNames = Object.keys(habitTypeMap)

export const regularTargetValue = 10
export const mainPriorityMainValue = 20
export const maxDailyScore = 100
export const highFiveValue = 20
export const dateFormat = 'ddd, MMM D'

export const loginCookieId = 'cookies-05282022' // Add current date as suffix to invalidate old cookies

export const textFieldStyle = { margin: 5 }